<template>
  <div>
    <el-row>
      <el-col :span="8" v-if="Detail.ageRquirement">
        <span class="label">年龄要求:</span>
        <span class="context">{{'、不限、15-25岁、25-35岁、35-45岁、45-55岁、55岁以上'.split('、')[Detail.ageRquirement]}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.sexRquirement">
        <span class="label">性别要求:</span>
        <span class="context">{{'、不限、男、女'.split('、')[Detail.sexRquirement]}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.nationRquirementName">
        <span class="label">民族要求:</span>
        <span class="context">{{Detail.nationRquirementName}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.workYearRquirement">
        <span class="label">工龄要求:</span>
        <span class="context">{{'、不限、1年以内、1-3年、3-5年、5-10年、10年以上'.split('、')[Detail.workYearRquirement]}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.healthProve">
        <span class="label">健康证明:</span>
        <span class="context">{{'、需要、不需要'.split('、')[Detail.healthProve]}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.performanceRquirement">
        <span class="label">业绩要求:</span>
        <span class="context" style="white-space: pre-wrap;line-height: 20px">{{Detail.performanceRquirement}}</span>
      </el-col>
      <template v-if="Detail.customField&&Detail.customField.length">
        <el-col :span="24" v-for="item in Detail.customField" :key="item.name" class="detail-item">
          <span class="item-name" >{{ item.name }}：</span>
          <span class="item-value">{{item.content}}</span>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    Detail: {
      type: Object
    }
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.detail-item {
    display: flex;
    // &:last-child{
    //   margin-bottom: 20px;
    // }
    .item-name {
      font-size: 14px;
      flex-shrink: 0;
      color: var(--FC6);
      margin-right: 3px;
    }
    .item-value {
      color: #333;
      font-size: 14px;
    }
  }
</style>
